/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,104a63.75508,63.75508,0,0,0-19.49121,3.04492l42.36035-70.9436a8.00043,8.00043,0,0,0-13.73828-8.20288L72.6416,135.90332c-.10449.17529-.19385.355-.28369.53442A63.97854,63.97854,0,1,0,128,104Zm0,112a47.97612,47.97612,0,0,1-41.15674-72.67017l.17749-.29736A47.99419,47.99419,0,1,1,128,216Z" />
    </Svg>
  );
}

export default NumberSix;
